/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ChallengePayload,
  GetMossAppChallengeResponse,
  GetSmsChallengeResponse,
  GetTotpChallengeResponse,
  GetWebAuthnChallengeResponse,
  TestOtpParams,
  ValidatePayload,
  ValidateSmsChallengeResponse,
  ValidateTotpChallengeResponse,
  ValidateWebAuthnChallengeResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OtpController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags otp-controller
   * @name Validate
   * @request POST:/api/v3/otp/validate
   */
  validate = (data: ValidatePayload, params: RequestParams = {}) =>
    this.http.request<
      | ValidateSmsChallengeResponse
      | ValidateTotpChallengeResponse
      | ValidateWebAuthnChallengeResponse,
      any
    >({
      path: `/v3/otp/validate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static validatePath = '/v3/otp/validate'
  static validateMethod = 'POST'
  /**
   * No description
   *
   * @tags otp-controller
   * @name TestOtp
   * @request POST:/api/v3/otp/test
   */
  testOtp = (query: TestOtpParams, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v3/otp/test`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static testOtpPath = '/v3/otp/test'
  static testOtpMethod = 'POST'
  /**
   * No description
   *
   * @tags otp-controller
   * @name Challenge
   * @request POST:/api/v3/otp/challenge
   */
  challenge = (data: ChallengePayload, params: RequestParams = {}) =>
    this.http.request<
      | GetMossAppChallengeResponse
      | GetSmsChallengeResponse
      | GetTotpChallengeResponse
      | GetWebAuthnChallengeResponse,
      any
    >({
      path: `/v3/otp/challenge`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static challengePath = '/v3/otp/challenge'
  static challengeMethod = 'POST'
}
